import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scrollTo";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Coaching" },
  { id: "story", label: "My Story" },
  { id: "philosophy", label: "Philosophy" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (open) {
      window.__lenis?.stop();
      document.body.style.overflow = "hidden";
    } else {
      window.__lenis?.start();
      document.body.style.overflow = "";
    }
  }, [open]);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 60 : 0);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b-[3px] border-ink transition-shadow duration-200 ${scrolled ? "shadow-[0_5px_0_rgba(13,13,13,0.9)]" : ""}`}
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
          <a href="#hero" onClick={go("hero")} data-testid="nav-logo-link" className="flex items-baseline gap-1.5 group">
            <span className="font-display font-extrabold text-xl sm:text-2xl tracking-tight uppercase">Evolve</span>
            <span className="font-hand text-2xl sm:text-3xl text-pink -rotate-3 group-hover:rotate-2 transition-transform duration-200">
              with Rosa
            </span>
          </a>
          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={go(l.id)}
                data-testid={`nav-link-${l.id}`}
                className="font-bebas text-lg tracking-[0.15em] uppercase hover:text-pink transition-colors"
              >
                {l.label}
              </a>
            ))}
            <button onClick={go("contact")} data-testid="nav-cta-button" className="btn-pop bg-pink text-cream text-sm px-5 py-2.5">
              Free Intro Call
            </button>
          </nav>
          <button className="lg:hidden p-2 -mr-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </header>
      {open && (
        <div className="fixed inset-0 z-40 bg-ink text-cream lg:hidden" data-testid="nav-mobile-menu">
          <div className="pt-24 px-8 flex flex-col gap-5">
            {LINKS.map((l, i) => (
              <a key={l.id} href={`#${l.id}`} onClick={go(l.id)} data-testid={`nav-mobile-link-${l.id}`} className="font-display font-extrabold uppercase text-4xl tracking-tight">
                <span className="font-hand font-bold text-pink text-2xl mr-3">0{i + 1}</span>
                {l.label}
              </a>
            ))}
            <button onClick={go("contact")} data-testid="nav-mobile-cta" className="btn-pop bg-pink text-cream px-6 py-4 mt-3 text-lg">
              Free Intro Call
            </button>
            <p className="font-hand text-2xl text-electric mt-4 -rotate-2">start where you are. evolve.</p>
          </div>
        </div>
      )}
    </>
  );
};
